import { ReactNode, useEffect, useRef, useState } from 'react';

import { ChevronDownIcon } from '@braskai/icons';
import { Icon, MenuProps, SpeakersPaletteTokens, useDeviceType } from '@braskai/ui-kit';

import { TeamspaceMenuItem } from '../TeamspaceMenuItem';
import { SChevronIcon, SContainer, SMenu } from './styled';

type TeamspaceMenuProps = {
  name: string;
  bottomBanner?: ReactNode;
  color?: SpeakersPaletteTokens;
  dataTestId?: string;
  isOpenSidebar?: boolean;
  isOwner?: boolean;
  topBanner?: ReactNode;
} & Omit<MenuProps, 'children'>;

export const TeamspaceMenu = ({
  name,
  color = 'midnight',
  dataTestId,
  isOpenSidebar = true,
  isOwner,
  options,
  ...props
}: TeamspaceMenuProps) => {
  const ref = useRef<HTMLButtonElement>(null);

  const [widthContainer, setWidthContainer] = useState<number>(0);

  const { isMobile } = useDeviceType();
  const [openMenu, setOpenMenu] = useState(false);
  const [hoverMenu, setHoverMenu] = useState(false);

  const handleOpen = (open: boolean) => {
    if (isMobile) {
      setWidthContainer(ref.current!.clientWidth);
    }

    setOpenMenu(open);
  };

  const onMouseEnter = () => setHoverMenu(true);
  const onMouseLeave = () => setHoverMenu(false);

  useEffect(() => {
    if (openMenu && !isOpenSidebar) {
      setOpenMenu(false);
    }
  }, [isOpenSidebar, openMenu]);

  return (
    <SMenu
      open={openMenu}
      options={options}
      placement="bottom"
      width={isMobile ? widthContainer : 186}
      disableMobileView
      handleOpen={handleOpen}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...props}
    >
      <SContainer data-testid="teamspace-menu" ref={ref}>
        <TeamspaceMenuItem
          name={name}
          color={color}
          dataTestId={dataTestId}
          hover={hoverMenu}
          isMobile={isMobile}
          isOpenSidebar={isOpenSidebar}
          isOwner={isOwner}
          size="lg"
          isLabel
        />
        {isOpenSidebar && (
          <SChevronIcon
            sx={{
              transform: `rotate(${openMenu ? 180 : 0}deg)`,
            }}
          >
            <Icon color={hoverMenu ? 'grey.900' : 'grey.500'} component={<ChevronDownIcon />} size={20} />
          </SChevronIcon>
        )}
      </SContainer>
    </SMenu>
  );
};
